/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum VisitsOrder {
  ID="ID"
}

/**
* VisitsOrder
*/
export const VisitsOrderEnumType = types.enumeration("VisitsOrder", [
        "ID",
      ])
